import {
  FreeLink as LibFreeLink,
  pickFreeLinkSettings
} from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';

export function FreeLink() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  return (
    <LibFreeLink
      {...freeLinkSettings}
      appAlias={meta.appAlias}
      appName={meta.appName}
      style={{
        link: {
          marginTop: '20px'
        }
      }}
    />
  );
}
